import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  IconSize,
  mobileOnly,
  tabletAndUp,
} from '@aboutyou/ui-components';
import {createGlobalStyle, css} from 'styled-components';

export const SustainabilityBadgeStyles = createGlobalStyle`
  .wrapper {
    align-items: center;
    display: flex;
    gap: 7px;
    margin-bottom: 4px;
    margin-top: 8px;
    height: 28px;
    padding: 4px 8px;
    background-color: transparent;
    display: inline-flex;
    gap: 4px;
    justify-content: initial;
    margin-bottom: 0;
    margin-top: 0;
    padding: 0;
  }

  .wrapper.banner {
    border-radius: 4px;
    display: flex;
    gap: 7px;
    margin-bottom: 4px;
    margin-top: 8px;
    padding: 4px 8px;
    background-color: #EBFBDF;
    justify-content: center;
  }

  .wrapper.banner.greyBG {
    background-color: #EBF1F8;
  }

  .badge {
    width: fit-content;
    display: inline-flex;
    align-items: center;
    margin-top: 1px;
    margin-right: 5px;
    background-color: rgba(190, 238, 146, 0.3);
    color: #416000;
    font-size: ${FONT_SIZES.px12};
    font-weight: ${FONT_WEIGHTS.mediumBold};
    direction: initial;
    line-height: 1;
    white-space: nowrap;
    gap: 5px;
    padding: 6px;
    height: auto;
    border-radius: 500px;
  }

  ${tabletAndUp(css`
    .badge {
      cursor: pointer;
      padding: 6px 10px 6px 6px;
      margin-top: 0px;
    }
    .wrapper.banner {
      margin-bottom: 0px;
      margin-top: 0px;
      margin-right: 15px;
      justify-content: space-between;
    }
  `)}

  .banner .badge {
    background-color: transparent;
  }

  .banner.noIcon .badge {
    margin: 0;
    padding: 0;
  }

  .leaf-svg {
    width: 14px;
    height: 14px;
    flex-basis: 14px;
  }

  ${tabletAndUp(css`
    .leaf-svg {
      width: 17px;
      height: 17px;
      flex-basis: 17px;
    }
  `)}

  .info-svg {
    width: ${IconSize.S}px;
    height: ${IconSize.S}px;
    flex-basis: ${IconSize.S}px;
    cursor: pointer;
  }

  ${tabletAndUp(css`
    .info-svg {
      width: ${IconSize.SS}px;
      height: ${IconSize.SS}px;
      flex-basis: ${IconSize.SS}px;
    }
  `)}

  .sustainabilityText {
    align-items: center;
    color: #416000;
    display: flex;
    font-size: ${FONT_SIZES.px10};
    font-weight: ${FONT_WEIGHTS.bold};
    margin: 0;
  }

  .sustainabilityText sub {
    margin-right: 3px;
  }

  ${mobileOnly(css`
    .sustainabilityText.slotSuggestCollectionPoint {
      display: none;
    }
  `)}

  .banner .badge .sustainabilityText {
    order: -1;
  }

  .banner.greyBG .badge .sustainabilityText {
    color: #37485C;
  }

  @keyframes slideUpEnter {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0%);
      opacity: 1;
    }
  }

  @keyframes fadeEnter {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .slideUpEnterAnimation {
    animation: 400ms ease-in-out 0ms 1 normal forwards running slideUpEnter;
  }

  .fadeEnterAnimation {
    animation: 400ms ease-in-out 0ms 1 normal forwards running fadeEnter;
  }

  .dialogWrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.6);
    pointer-events: all;
    z-index: 101;
    touch-action: none;
    will-change: opacity;
  }

  .backdrop {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .flyout {
    position: relative;
    z-index: 101;
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: calc(100% - 4vh);
    margin: 4vh auto 0;
    pointer-events: none;
    will-change: transform, opacity;
  }

  .flyoutContent {
    position: relative;
    width: 100%;
    max-height: 100%;
    background: ${COLORS.White};
    border-radius: 8px 8px 0 0;
    pointer-events: all;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .flyoutInnerContent {
    max-height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow: hidden;
  }

  .dialogWrapper header {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0.625rem 0 0.75rem;
    border-bottom: 1px solid #e5e5e5;
    cursor: pointer;
    flex-shrink: 0;
    overscroll-behavior: contain;
  }

  .headerContent {
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: center;
  }

  .headerContent span {
    letter-spacing: auto;
    color: ${COLORS.Black};
    font-size: ${FONT_SIZES.px20};
    font-weight: ${FONT_WEIGHTS.bold};
  }

  .bodyContent {
    padding: 1.5rem;
  }

  .bodyContent button {
    background-color: ${COLORS.Black};
    color: ${COLORS.White};
    cursor: pointer;
    outline: none;
    margin: 1rem 0 0 0;
    font-size: ${FONT_SIZES.px14};
    font-weight: ${FONT_WEIGHTS.bold};
    text-align: center;
    border-radius: 2px;
    transition: box-shadow 280ms cubic-bezier(0.4,0,0.2,1), transform 0.25s cubic-bezier(0.25,0.46,0.45,0.94);
    text-decoration: none;
    box-shadow: 0 3px 5px 0 rgba(0,0,0,0.15);
    border: 0;
    padding: 16px 40px;
    width: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
    will-change: transform,opacity;
    justify-content: center;
  }
`;
